import { Controller } from '@hotwired/stimulus';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';
import {
  dispatchCustomEvent,
  subscribeCustomEvent,
  unsubscribeCustomEvent,
} from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['overlay'];

  connect() {
    this.boundShow = this.show.bind(this);
    this.boundHide = this.hide.bind(this);

    subscribeCustomEvent('loading-indicator:show', this.boundShow);
    subscribeCustomEvent('loading-indicator:hide', this.boundHide);
  }

  disconnect() {
    unsubscribeCustomEvent('loading-indicator:show', this.boundShow);
    unsubscribeCustomEvent('loading-indicator:hide', this.boundHide);
  }

  show() {
    showElement(this.overlayTarget);
  }

  hide() {
    hideElement(this.overlayTarget);
  }
}

export function show() {
  dispatchCustomEvent('loading-indicator:show');
}

export function hide() {
  dispatchCustomEvent('loading-indicator:hide');
}
